import { render } from "./EmailOnboardingSidePanel.vue?vue&type=template&id=0231813c"
import script from "./EmailOnboardingSidePanel.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingSidePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__